import { Component } from '@angular/core';

export const WEBINAR_REGISTER_URL = 'https://us02web.zoom.us/webinar/register/WN_8eY03ZNWQoCIsYL5zxS4DA';

@Component({
  selector: 'app-banner-dialog',
  templateUrl: './banner-dialog.component.html'
})
export class BannerDialogComponent {
  redirectTo(route: string): void {
    if (route === 'register') {
      window.open(WEBINAR_REGISTER_URL, '_blank');
      // window.open('https://avanacuso.com/webinar-finding-legal-counsel/#register', '_blank');
    }
    // else {
    //   window.open('https://avanacuso.com/webinar-finding-legal-counsel/', '_blank');
    // }
  }
}
